import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import heroImage from '../Images/landing-finding-banner.png';

function HeroSection() {
  return (
    <div className={css.heroSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.heroImg}>
          <img src={heroImage} alt="insurance and warranty hero" />
        </div>
        <div className={css.heroInfo}>
          <h2>
            <FormattedMessage id="InsuranceAndFinancePage.HeroSection.title" />
          </h2>
          <p>
            <FormattedMessage id="InsuranceAndFinancePage.HeroSection.description" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
